import { useJsApiLoader } from "@react-google-maps/api";
import Config from "./Config";

// One Google Maps loader for the whole app. The loader refuses to run twice with
// different options, so every map page (pickers, car tracking, staff tracking) must
// load it the same way - through this hook.
const useGoogleMaps = () => useJsApiLoader({
    googleMapsApiKey: Config.KEYS.MAP_KEY || "",
    libraries: Config.GOOGLE_MAPS_LIBRARIES,
});

export default useGoogleMaps;
